import angular from 'angular';

import CommandComponent from './commands.component';
import CommandService from './commands.service';
import ControlsComponent from './controls/controls.component';
import CommandControlService from './controls/controls.service';
import CommandHistoryComponent from './history/history.component';
import CommandHistoryService from './history/history.service';
import CommandStatusComponent from './status/status.component';
import CommandStatusService from './status/status.service';
import CommandsTextService from './commands-text.service';
import CommandTranslateFilter from './command-translate.filter';

const assetDetailsDashboardModule = angular.module('asset-commands', []);

assetDetailsDashboardModule
  .service('CommandStatusService', CommandStatusService)
  .service('CommandService', CommandService)
  .service('CommandHistoryService', CommandHistoryService)
  .service('CommandControlsService', CommandControlService)
  .service('CommandsTextService', CommandsTextService)
  .filter('commandTranslateFilter', CommandTranslateFilter)
  .component('commandComponent', CommandComponent)
  .component('commandControls', ControlsComponent)
  .component('commandHistory', CommandHistoryComponent)
  .component('commandStatus', CommandStatusComponent);

export default assetDetailsDashboardModule.name;
